import './App.css';
import {Button, Col, Divider, Popover, Row, Typography} from 'antd';
import ReactCountryFlag from "react-country-flag";
import About from "./About";
import Pricing from "./Pricing";
import {
    InfoCircleOutlined, LinkedinOutlined,
} from "@ant-design/icons";
import {NavLink} from "react-router-dom";


const { Title, Text } = Typography;

function Header() {
    return (
        <>
            <Row style={{
                  maxWidth: 1280,
                  margin: '0 auto',
                  padding: 24
                }}>
                <Col span={16} className='Header'>
                <NavLink className={"menu"} to={'/'}>
                    <h1>Stork<span style={{fontWeight: '300'}}>Stay</span></h1>
                </NavLink>
              
                <NavLink className={"menu"} to={'/contacts'}>
                <h3>Contacts</h3>
                </NavLink>
            
                <NavLink to={'/pricing'}>
                    <h3>Pricing</h3>
                </NavLink>
                <NavLink className={"menu"} to={'/about'}>
                    <h3>About</h3>
                </NavLink>
                </Col>
                <Col span={8} style={{textAlign: "right"}}>
                <NavLink className={"menu"} to={'/login'}>
                        <Button type='text' size='large'>
                        Log in
                        </Button>
                </NavLink>

                <NavLink className={"menu"} to={'/register'}>
                    <Button 
                    size="large" 
                    color="default"
                    variant="solid"
                    style={{
                        marginTop: 20,
                        marginLeft: 16,
                        }}
                    >
                    Sign up
                    </Button>
                </NavLink>
                </Col>
            </Row>
        </>
    );
}

export default Header;
